<div class="container-form">
  <!--BIENVENIDA -->
  <form action="" autocomplete="off" [formGroup]="formStepBienvenidaLto" class="form">
    <div style="padding-top: 20px;">
    <!-- Referrer -->
    <div class="title" *ngIf="referrerPage">
      <label for="" class="text-label">Tu número de teléfono</label>
      <div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" style="width: 40%">
          <mat-select formControlName="referrerCellPhoneCountryCode">
            <mat-option
              *ngFor="let opcion of phoneCountryCode"
              [value]="opcion.countryCode"
            >
              <img src="{{ opcion.imageUrl }}" class="image" />

              {{ opcion.phoneCode }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              formStepBienvenidaLto.controls['referrerCellPhoneCountryCode'].invalid &&
              formStepBienvenidaLto.controls['referrerCellPhoneCountryCode'].touched
            "
          >
            <span
              *ngIf="
                formStepBienvenidaLto.controls['referrerCellPhoneCountryCode'].errors &&
                formStepBienvenidaLto.controls['referrerCellPhoneCountryCode'].errors[
                  'required'
                ]
              "
              >Debe completar este campo</span
            >
          </mat-error>
        </mat-form-field>
        <!-- TELEFONO CELULAR -->
        <mat-form-field appearance="outline" subscriptSizing="dynamic" style="width: 60%">
          <input
            appNumber
            matInput
            placeholder="Ingrese su número de celular"
            formControlName="referrerMobilePhoneNumber"
            matTooltip="Verifica que este escrito correctamente tu Teléfono ya que deberás validarlo y será el oficial donde recibirás comunicaciones de parte de Vemo."
          />
          <mat-error
            *ngIf="
              formStepBienvenidaLto.controls['referrerMobilePhoneNumber'].invalid &&
              formStepBienvenidaLto.controls['referrerMobilePhoneNumber'].touched
            "
          >
            <span
              *ngIf="
                formStepBienvenidaLto.controls['referrerMobilePhoneNumber'].errors &&
                formStepBienvenidaLto.controls['referrerMobilePhoneNumber'].errors[
                  'required'
                ]
              "
              >Debe completar este campo</span
            >
          </mat-error>
          <mat-error
            class="error-phone"
            *ngIf="
              formStepBienvenidaLto.controls['referrerMobilePhoneNumber'].hasError(
                'pattern'
              )
            "
            >Debe ingresar 10 caracteres.
          </mat-error>
          <mat-icon matSuffix>notification_important</mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-6 div-input">
      <!-- NOMBRES -->
      <label for="" class="text-label">{{referrerPage ? 'Nombre(s) de tu referido' : 'Nombre(s)'}}</label>
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Ingrese su nombre completo"
          formControlName="firstName"
          oninput="this.value = this.value.toUpperCase()"
          (keydown)="isLetter($event)"
          onkeypress="return /[ña-zÇÖÜÄËÏA-Z\s]/i.test(event.key)"
        />
        <mat-error
          *ngIf="
            formStepBienvenidaLto.controls['firstName'].invalid &&
            formStepBienvenidaLto.controls['firstName'].touched
          "
        >
          <span
            *ngIf="
              formStepBienvenidaLto.controls['firstName'].errors &&
              formStepBienvenidaLto.controls['firstName'].errors['required']
            "
            >Debe completar este campo</span
          >
          <span
            *ngIf="
              formStepBienvenidaLto.controls['firstName'].errors &&
              formStepBienvenidaLto.controls['firstName'].errors['pattern']
            "
            >Verifique los espacios en blanco</span
          >
        </mat-error>
        <mat-error
          *ngIf="
            formStepBienvenidaLto.controls['firstName'].hasError('maxlength')
          "
          >Máximo 45 caracteres.
        </mat-error>
        <mat-error
          *ngIf="
            formStepBienvenidaLto.controls['firstName'].hasError('minlength')
          "
          >Mínimo 2 caracteres.
        </mat-error>
      </mat-form-field>
      <!-- APELLIDOS -->
      <label for="" class="text-label">{{referrerPage ? 'Apellido(s) de tu referido' : 'Apellido(s)'}}</label>
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Ingrese su apellido(s)"
          formControlName="lastName"
          oninput="this.value = this.value.toUpperCase()"
          (keydown)="isLetter($event)"
          onkeypress="return /[ña-zÇÖÜÄËÏA-Z\s]/i.test(event.key)"
        />
        <mat-error
          *ngIf="
            formStepBienvenidaLto.controls['lastName'].invalid &&
            formStepBienvenidaLto.controls['lastName'].touched
          "
        >
          <span
            *ngIf="
              formStepBienvenidaLto.controls['lastName'].errors &&
              formStepBienvenidaLto.controls['lastName'].errors['required']
            "
            >Debe completar este campo</span
          >
          <span
            *ngIf="
              formStepBienvenidaLto.controls['lastName'].errors &&
              formStepBienvenidaLto.controls['lastName'].errors['pattern']
            "
            >Verifique los espacios en blanco</span
          >
        </mat-error>
        <mat-error
          *ngIf="
            formStepBienvenidaLto.controls['lastName'].hasError('maxlength')
          "
          >Máximo 45 caracteres.
        </mat-error>
        <mat-error
          *ngIf="
            formStepBienvenidaLto.controls['lastName'].hasError('minlength')
          "
          >Mínimo 2 caracteres.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-6 div-input">
      <!-- CORREO ELECTRONICO -->
      <label for="" class="text-label">{{referrerPage ? 'Correo electrónico de tu referido' : 'Correo electrónico'}}</label>
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Ingrese su correo electrónico"
          [formControl]="emailCtrl"
          type="email"
          (keydown)="deleteSpaceInit($event)"
          matTooltip="Verifica que este escrito correctamente tu correo ya que deberás validarlo y será el oficial donde recibirás comunicaciones de parte de Vemo."
        />
        <mat-error *ngIf="emailCtrl.invalid && emailCtrl.touched">
          <span *ngIf="emailCtrl.errors && emailCtrl.errors['required']"
            >Debe completar este campo</span
          >
        </mat-error>
        <mat-error *ngIf="emailCtrl.hasError('pattern')" class="error-email"
          >Formato incorrecto.
        </mat-error>
        <mat-error *ngIf="emailCtrl.hasError('emailEnd')" class="textProviders">
          Formato de email incorrecto.
        </mat-error>
        <mat-icon matSuffix>notification_important</mat-icon>
      </mat-form-field>

      <!-- CODIGO PAIS -->
      <label for="" class="text-label">Número de teléfono</label>
      <div>
        <mat-form-field appearance="outline" style="width: 40%">
          <mat-select formControlName="cellPhoneCountryCode">
            <mat-option
              *ngFor="let opcion of phoneCountryCode"
              [value]="opcion.countryCode"
            >
              <img src="{{ opcion.imageUrl }}" class="image" />

              {{ opcion.phoneCode }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              formStepBienvenidaLto.controls['cellPhoneCountryCode'].invalid &&
              formStepBienvenidaLto.controls['cellPhoneCountryCode'].touched
            "
          >
            <span
              *ngIf="
                formStepBienvenidaLto.controls['cellPhoneCountryCode'].errors &&
                formStepBienvenidaLto.controls['cellPhoneCountryCode'].errors[
                  'required'
                ]
              "
              >Debe completar este campo</span
            >
          </mat-error>
        </mat-form-field>
        <!-- TELEFONO CELULAR -->
        <mat-form-field appearance="outline" style="width: 60%">
          <input
            appNumber
            matInput
            placeholder="Ingrese su número de celular"
            formControlName="mobilePhoneNumber"
            matTooltip="Verifica que este escrito correctamente tu Teléfono ya que deberás validarlo y será el oficial donde recibirás comunicaciones de parte de Vemo."
          />
          <mat-error
            *ngIf="
              formStepBienvenidaLto.controls['mobilePhoneNumber'].invalid &&
              formStepBienvenidaLto.controls['mobilePhoneNumber'].touched
            "
          >
            <span
              *ngIf="
                formStepBienvenidaLto.controls['mobilePhoneNumber'].errors &&
                formStepBienvenidaLto.controls['mobilePhoneNumber'].errors[
                  'required'
                ]
              "
              >Debe completar este campo</span
            >
          </mat-error>
          <mat-error
            class="error-phone"
            *ngIf="
              formStepBienvenidaLto.controls['mobilePhoneNumber'].hasError(
                'pattern'
              )
            "
            >Debe ingresar 10 caracteres.
          </mat-error>
          <mat-icon matSuffix>notification_important</mat-icon>
        </mat-form-field>
      </div>
    </div>

    <div class="col-md-6 div-input">
      <!-- CUIDAD TRABAJAS -->
      <label for="" class="text-label" *ngIf="!this.city">{{referrerPage ? '¿En que ciudad trabaja?' : '¿En que ciudad trabajas?'}}</label>
      <mat-form-field appearance="outline" *ngIf="!this.city">
        <mat-select
          formControlName="workCityId"
          placeholder="Seleccione una ciudad"
        >
          <mat-option *ngFor="let work of workingCities" [value]="work.id">
            {{ work.name }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            formStepBienvenidaLto.controls['workCityId'].invalid &&
            formStepBienvenidaLto.controls['workCityId'].touched
          "
        >
          <span
            *ngIf="
              formStepBienvenidaLto.controls['workCityId'].errors &&
              formStepBienvenidaLto.controls['workCityId'].errors['required']
            "
            >Debe completar este campo</span
          >
        </mat-error>
      </mat-form-field>
      <!-- PLATAFORMA -->
      <label for="" class="text-label">Plataforma de trabajo</label>
      <mat-form-field appearance="outline" matTooltip="Plataforma">
        <mat-select
          formControlName="platformId"
          placeholder="Seleccione una plataforma"
        >
          <mat-option *ngFor="let opcion of platformList" [value]="opcion.id">
            {{ opcion.name }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            formStepBienvenidaLto.controls['platformId'].invalid &&
            formStepBienvenidaLto.controls['platformId'].touched
          "
        >
          <span
            *ngIf="
              formStepBienvenidaLto.controls['platformId'].errors &&
              formStepBienvenidaLto.controls['platformId'].errors['required']
            "
            >Debe completar este campo</span
          >
        </mat-error>
      </mat-form-field>
    </div>

    <!-- AVISO DE PRIVACIDAD -->
    <div class="privacy-agreement">
      <div class="privacy-agreement__checkbox-wrapper div-check">
        <mat-checkbox formControlName="privacyNoticeAccepted"> </mat-checkbox>
        Acepto el Aviso de Privacidad.
        <button
          mat-icon-button
          aria-label="Example icon button with a vertical three dot icon"
          class="color-button"
          (click)="openNoticeOfPrivacyDialog()"
        >
          <mat-icon>help</mat-icon>
        </button>
      </div>
      <div *ngIf="!referrerPage" class="privacy-agreement__checkbox-wrapper div-check">
        <mat-checkbox formControlName="buroRequestAccepted"></mat-checkbox>
        Acepto la Consulta de Buró.
      </div>
      <div *ngIf="!referrerPage" class="privacy-agreement__tnc">
        <button
          type="button"
          color="primary"
          (click)="showBuroTerms = !showBuroTerms"
          [attr.aria-expanded]="showBuroTerms"
          aria-controls="buro-terms-panel">
          Términos y condiciones consulta de buró
          <mat-icon>
            {{ showBuroTerms ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </button>
      </div>

      <div
        id="buro-terms-panel"
        class="privacy-agreement__panel"
        *ngIf="showBuroTerms"
      >
        <div class="privacy-agreement__text">
          <p>
            <span>Por este conducto declaro que la presente es una autorización expresa e inequívoca a favor de Financiera por el Impulso Económico, S.A. de C.V. SOFOM E.N.R. (En lo sucesivo, VEMO Impulso) para que a través de sus funcionarios facultados realice las investigaciones correspondientes sobre mi comportamiento e historial crediticio, ante las Sociedades de Información Crediticia.</span>
            <span>Declaro que conozco la naturaleza y alcance de la información que la Sociedad de Información Crediticia otorgará a VEMO Impulso, cuando lo solicite, así como el uso que esta última le dará.</span>
            <span>También autorizo a VEMO Impulso para realizar consultas periódicas de mi historial crediticio durante un periodo de 3 años contados a partir de esta autorización o en todo caso durante el tiempo que mantengamos una relación jurídica.</span>
            <span>Declaro que estoy consciente y acepto que esta Autorización quede bajo custodia de VEMO Impulso para efectos del control y cumplimiento del artículo 28 de la Ley para Regular las Sociedades de Información Crediticia.</span>
          </p>
        </div>
      </div>
    </div>
    <mat-error
      class="error"
      *ngIf="
        formStepBienvenidaLto.controls['privacyNoticeAccepted'].invalid &&
        formStepBienvenidaLto.controls['privacyNoticeAccepted'].touched
      "
    >
      <span
        *ngIf="
          formStepBienvenidaLto.controls['privacyNoticeAccepted'].errors &&
          formStepBienvenidaLto.controls['privacyNoticeAccepted'].errors[
            'required'
          ]
        "
        >Es necesario aceptar terminos</span
      >
    </mat-error>

    <!-- WhatsApp Verification Code. -->
    <div *ngIf="(whatsAppCodeSent && requestMode === 1) || totalAttempts > 0" class="col-md-6 div-input code-verification">
      <h3>Se ha enviado un codigo de verificación a tu WhatsApp</h3>

      <h4>Ingrese tu código de 6 dígitos</h4>

      <form class="form" *ngIf="whatsAppCodeFg" [formGroup]="whatsAppCodeFg">
        <div class="form__inputs-wrapper">
          <input
            type="text"
            maxlength="1"
            class="form__inputs-wrapper__input"
            *ngFor="let i of [0,1,2,3,4,5]; let idx = index"
            #codeInputs
            (focus)="onFocus(idx)"
            (input)="onInput($event, idx)"
            (keydown)="onKeyDown($event, idx)"
          />
        </div>
      </form>

      <p class="whatsApp-error" *ngIf="totalAttempts > 0 && totalAttempts !== MAX_WHATSAPP_ATTEMPTS">Codigo incorrecto. {{ totalAttempts !== 1 ? 'Quedan' : 'queda' }} {{ MAX_WHATSAPP_ATTEMPTS - totalAttempts }} {{ totalAttempts !== 1 ? 'intentos' : 'intento' }}</p>
      <p class="whatsApp-error" *ngIf="totalAttempts >= MAX_WHATSAPP_ATTEMPTS">Recargar la pagina para volverlo a intentar</p>

      <button
        *ngIf="totalAttempts > 0 && totalAttempts !== MAX_WHATSAPP_ATTEMPTS"
        (click)="sendWhatsappCode(true)"
        mat-raised-button
        [disabled]="isWaitingApi"
      >
        Reenviar codigo
      </button>
    </div>
    </div>
  </form>
</div>

<div class="div-button-form">
  <div class="boton-siguiente-lto-container">
    <div class="boton-siguiente-lto-container__buttons">
      <button
        *ngIf="requestMode === 0 || (requestMode === 1 && whatsAppCodeSent && totalAttempts < MAX_WHATSAPP_ATTEMPTS) || promoter || referrerPage"
        class="boton-siguiente-lto"
        (click)="saveStepWelcome()"
        mat-raised-button
        [disabled]="
          !isFormValid || emailCtrl.invalid || isWaitingApi ||
          (requestMode === 1 && !promoter && !referrerPage && (!isCodeComplete() || !whatsAppCodeSent || totalAttempts === MAX_WHATSAPP_ATTEMPTS))
        "
        onclick="dataLayer.push({'event': 'login'});"
      >
        {{ referrerPage ? '¡REFERIR AHORA!' : 'RECIBIR PROPUESTA' }}
      </button>

      <!-- SEND CODE BY WHATSAPP. -->
      <button
        *ngIf="requestMode === 1 && !whatsAppCodeSent && totalAttempts < MAX_WHATSAPP_ATTEMPTS && !promoter && !referrerPage"
        class="boton-siguiente-lto"
        (click)="sendWhatsappCode()"
        mat-raised-button
        [disabled]="!isFormValid || emailCtrl.invalid || isWaitingApi"
      >
        Enviar código por WhatsApp
      </button>

      <!-- RELOAD PAGE WHEN ATTEMPTS ARE EXHAUSTED. -->
      <button
        *ngIf="totalAttempts >= MAX_WHATSAPP_ATTEMPTS"
        class="boton-siguiente-lto"
        (click)="reloadPage()"
        mat-raised-button
      >
        Recargar Página
      </button>

      <mat-spinner class="save-spinner" diameter="26" *ngIf="isWaitingApi"></mat-spinner>
    </div>
  </div>
</div>
